import React, { useContext, useEffect, Fragment } from 'react'
import { useLazyQuery, NetworkStatus } from '@apollo/client'
import { Grid } from '@material-ui/core'
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles'

import { DailyMonitoringDetailsFiltersContext } from '../../../../context/DailyMonitoringDetailsFiltersContext'

import { MultipleShoppingCartTotals } from '../../../../types/MultipleShoppingCart'
import CardWidgetSkeleton from '../../../../components/skeletons/CardWidgetSkeleton'
import TotalTicketAverage from './TotalTicketAverage'
import MultipleShoppingCartTicketAverage from './MultipleShoppingCartTicketAverage'
import MultipleShoppingCartTicketGrowth from './MultipleShoppingCartTicketGrowth'
import MultipleShoppingCartOpenGMV from './MultipleShoppingCartOpenGMV'
import MultipleShoppingCartFailed from './MultipleShoppingCartFailed'
import MultipleShoppingCartCancelled from './MultipleShoppingCartCancelled'
import ShoppingCartsGMV from './ShoppingCartsGMV'
import ShoppingCartsQuantity from './ShoppingCartsQuantity'
import MultipleShoppingSalesHistory from './MultipleShoppingSalesHistory'
import MultipleShoppingCancelledDeliveredHistory from './MultipleShoppingCancelledDeliveredHistory'
import ShoppingCartsPaymentTypes from './ShoppingCartsPaymentTypes'
import ShoppingCartsPaymentMethods from './ShoppingCartsPaymentMethods'
import { GET_MULTIPLE_SHOPPING_CART_TOTALS } from '../../../../queries/multipleShoppingCarts'

interface MultipleShoppingCartTotalsInterface {
  multipleShoppingCartTotals: MultipleShoppingCartTotals
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      marginTop: theme.spacing(2)
    }
  })
)

const Index = (): JSX.Element => {
  const classes = useStyles()
  const { filters } = useContext(DailyMonitoringDetailsFiltersContext)

  const [getData, { loading, error, data, networkStatus }] = useLazyQuery<MultipleShoppingCartTotalsInterface>(
    GET_MULTIPLE_SHOPPING_CART_TOTALS, {
      notifyOnNetworkStatusChange: true,
      variables: {
        filters
      }
    }
  )

  useEffect(() => {
    getData({
      variables: {
        filters
      }
    })
  }, [filters])

  if (networkStatus === NetworkStatus.refetch) return <CardWidgetSkeleton />
  if (loading || !data) return <CardWidgetSkeleton />
  if (error) return <p>Error :(</p>

  return (
    <Fragment>
      <Grid container spacing={1} xs={12} className={classes.container}>
        <Grid item sm={12} md={4}>
          <TotalTicketAverage { ...data.multipleShoppingCartTotals } />
        </Grid>
        <Grid item sm={12} md={4}>
          <MultipleShoppingCartTicketAverage { ...data.multipleShoppingCartTotals } />
        </Grid>
        <Grid item sm={12} md={4}>
          <MultipleShoppingCartTicketGrowth { ...data.multipleShoppingCartTotals } />
        </Grid>
      </Grid>
      <Grid container spacing={1} xs={12} className={classes.container}>
        <Grid item sm={12} md={4}>
          <MultipleShoppingCartOpenGMV { ...data.multipleShoppingCartTotals } />
        </Grid>
        <Grid item sm={12} md={4}>
          <MultipleShoppingCartFailed { ...data.multipleShoppingCartTotals } />
        </Grid>
        <Grid item sm={12} md={4}>
          <MultipleShoppingCartCancelled { ...data.multipleShoppingCartTotals } />
        </Grid>
      </Grid>
      <Grid container spacing={1} xs={12} className={classes.container}>
        <Grid item sm={12} md={6}>
          <ShoppingCartsGMV { ...data.multipleShoppingCartTotals } />
        </Grid>
        <Grid item sm={12} md={6}>
          <ShoppingCartsQuantity { ...data.multipleShoppingCartTotals } />
        </Grid>
      </Grid>
      <Grid container spacing={1} xs={12} className={classes.container}>
        <Grid item sm={12}>
          <MultipleShoppingSalesHistory />
        </Grid>
      </Grid>
      <Grid container spacing={1} xs={12} className={classes.container}>
        <Grid item sm={12}>
          <MultipleShoppingCancelledDeliveredHistory />
        </Grid>
      </Grid>
      <Grid container spacing={1} xs={12} className={classes.container}>
        <Grid item sm={12} md={6}>
          <ShoppingCartsPaymentTypes />
        </Grid>
        <Grid item sm={12} md={6}>
          <ShoppingCartsPaymentMethods />
        </Grid>
      </Grid>
    </Fragment>
  )
}

export default Index
